import { useEffect } from "react";
import "./Procedimentos.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Tratamentos = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      delay: 200,
    });

    setTimeout(() => {
      AOS.refresh();
    }, 1000);
  }, []);

  const cardsData = [
    {
      id: 1,
      href: "/corpo",
      icon: "/images/icones/png/002-surgery.png",
      alt: "Ícone 1",
      title: "Cirurgias de Corpo",
      description: "A arte de esculpir e harmonizar a silhueta.",
    },
    {
      id: 2,
      href: "/face",
      icon: "/images/icones/png/001-facial.png",
      alt: "Ícone 2",
      title: "Cirurgias de Face",
      description: "Renovação e equilíbrio para expressões únicas.",
    },
    {
      id: 3,
      href: "/mamas",
      icon: "/images/icones/png/003-breast.png",
      alt: "Ícone 3",
      title: "Cirurgias de Mamas",
      description: "Transformações que unem estética, confiança e bem estar.",
    },
  ];

  const centralCardsData = [
    {
      id: 4,
      href: "/intimas",
      icon: "/images/icones/png/004-vagina.png",
      alt: "Ícone 4",
      title: "Cirurgias Íntimas",
      description: "Cuidado e delicadeza para uma nova intimidade.",
    },
    {
      id: 5,
      href: "/reparadoras",
      icon: "/images/icones/png/005-scalpel.png",
      alt: "Ícone 5",
      title: "Cirurgias Reparadoras",
      description: "Restaurando histórias, reconquistando autoestima.",
    },
  ];

  const Card = ({ href, icon, alt, title, description }) => (
    <a href={href} className="tratamento-card">
      <div className="tratamento-icon">
        <img src={icon || "/placeholder.svg"} alt={alt} />
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </a>
  );

  return (
    <section id="tratamentos">
      <h2 data-aos="fade-up">Cirurgias</h2>

      <div className="posiciamentos-card">
        <div
          className="tratamentos-container"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {cardsData.map((procedure) => (
            <Card
              key={procedure.id}
              href={procedure.href}
              icon={procedure.icon}
              alt={procedure.alt}
              title={procedure.title}
              description={procedure.description}
            />
          ))}
        </div>

        <div
          className="container-central"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {centralCardsData.map((procedure) => (
            <div className="container-card" key={procedure.id}>
              <Card
                href={procedure.href}
                icon={procedure.icon}
                alt={procedure.alt}
                title={procedure.title}
                description={procedure.description}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tratamentos;
